<div class="sfcid-dialog-title" mat-dialog-title>
  <span>
    <mat-icon class="q9-logo-color icon red-icon" svgIcon="warn_icon"></mat-icon>
    <div>
      <span>{{ 'SF_CONNECTIONS.ORG_CONNECTION_FAILED_NEW' | translate }}</span>
      <span class="hint-text">{{ 'SF_CONNECTIONS.FIX_ISSUE_HINT' | translate }}</span>
    </div>
  </span>
  <q9-dialog-close-button style="margin: 0" (click)="acknowledge()"></q9-dialog-close-button>
</div>

<mat-dialog-content>
  <q9-section>
    <div content>
      <ng-container>
        <div class="sfcid-banner sfcid-error-banner">
          <div *ngIf="!alreadyConnected(); else alreadyConnectedTemplate">
            {{ errorSignal() }}
          </div>
        </div>
        <ng-template #alreadyConnectedTemplate>
          <div class="sfcid-already-connected-error">
            <div
              [innerHTML]="
                'SF_CONNECTIONS.ALREADY_CONNECTED_MSG_1_V2'
                  | translate: {username: data.connectedUsername, space: data.connectedSpaceName}
              "></div>

            <div [innerHTML]="'SF_CONNECTIONS.ALREADY_CONNECTED_MSG_2' | translate"></div>
          </div>
        </ng-template>
        <q9ma-connection-details-list [items]="detailsItems"></q9ma-connection-details-list>
      </ng-container>

      <div>
        {{ 'SF_CONNECTIONS.STILL_STUCK_QUESTION' | translate }}
        <a target="_blank" [href]="emailLink">{{ 'SF_CONNECTIONS.CONTACT_US' | translate }}</a>
        {{ 'SF_CONNECTIONS.AFTER_CONTACT_STEPS' | translate }}
      </div>
    </div>
  </q9-section>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-primary-button [color]="data.color" (click)="acknowledge()">
    {{ 'SF_CONNECTIONS.TRY_AGAIN_LATER' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
